import { MasterDataTypesEnum, BusinessError, ErrorKind, EntityKind, ListMasterDataResponseSchema, } from '@mgdis/eu-domain';
export class MasterDataRestAdapter {
    restHttpAdapter;
    tenantId;
    masterDataUrlMap;
    constructor({ tenantId, restHttpAdapter }) {
        this.tenantId = tenantId;
        this.restHttpAdapter = restHttpAdapter;
        this.masterDataUrlMap = new Map([
            [
                MasterDataTypesEnum.TYPES_CONTRIBUTION_INFORMATION,
                this.#buildReferentielFinancementUrl(MasterDataTypesEnum.TYPES_CONTRIBUTION_INFORMATION),
            ],
            [
                MasterDataTypesEnum.MOTIFS_CONTRIBUTION_INFORMATION,
                this.#buildReferentielFinancementUrl(MasterDataTypesEnum.MOTIFS_CONTRIBUTION_INFORMATION),
            ],
        ]);
    }
    /**
     * Build url for master data coming from referentiel-financement
     *
     * @param masterDataType - Type of master data being fetched
     * @returns master data complete url
     */
    #buildReferentielFinancementUrl(masterDataType) {
        return `/referentiel-financement/api/tenants/${this.tenantId}/${masterDataType}`;
    }
    /**
     * List master datas of the given type
     *
     * @param masterDataType - Type of master data to fetch
     * @param params - Query params to send with url
     * @returns the list of fetched master data
     */
    async listMasterDatasOfType(masterDataType, { odataFilter } = {}) {
        const urlToFetch = this.masterDataUrlMap.get(masterDataType);
        if (!urlToFetch) {
            return {
                error: new BusinessError(ErrorKind.BUSINESS, {
                    entity: EntityKind.MASTER_DATA,
                    message: `Type ${masterDataType} does not exist or is not configured yet.`,
                }),
            };
        }
        try {
            const res = await this.restHttpAdapter.get(urlToFetch, {
                params: {
                    $filter: odataFilter ?? `actif eq true`,
                    $select: 'id,title',
                    $orderby: 'title asc',
                    $top: 1000,
                },
            });
            const result = await ListMasterDataResponseSchema.safeParseAsync(res.data);
            if (!result.success) {
                return {
                    error: new BusinessError(ErrorKind.TECHNICAL_ERROR, {
                        entity: EntityKind.MASTER_DATA,
                        message: `[MasterDataRestAdapter] listMasterDatasOfType - Error parsing. ${result.error.message}`,
                    }),
                };
            }
            return { response: result.data._embedded.items };
        }
        catch (error) {
            console.error('[MasterDataRestAdapter] listMasterDatasOfType', error);
            return {
                error: new BusinessError(ErrorKind.TECHNICAL_ERROR, {
                    entity: EntityKind.MASTER_DATA,
                    message: error instanceof Error ? error.message : 'Unknown error',
                }),
            };
        }
    }
}
//# sourceMappingURL=master-data-rest.adapter.js.map